// extracted by mini-css-extract-plugin
export var headlineContainer = "headline-module--headlineContainer--q1m86";
export var show = "headline-module--show--2s_Uu";
export var subTitle = "headline-module--subTitle--1-Eh2";
export var headline = "headline-module--headline--2plza";
export var stroke = "headline-module--stroke--34rHR";
export var right = "headline-module--right--3CYGU";
export var left = "headline-module--left--Q-fv0";
export var toEdge = "headline-module--toEdge--1DCFU";